import { Box } from "@chakra-ui/layout";
import { Modal } from "antd";
import FormGrupoUnidade from "./FormGrupoUnidade";

interface ModalGrupoUnidadeProps {
  visible: boolean;
  onClose: () => any;
  onSuccess?: (result: any) => any;
  defaultValue?: Record<string, any>;
  editId?: string;
  showCadastroUnidades?: boolean;
}
function ModalGrupoUnidade({
  visible,
  onClose,
  defaultValue,
  onSuccess,
  editId,
  showCadastroUnidades,
}: ModalGrupoUnidadeProps) {
  return (
    <Modal
      centered
      visible={visible}
      footer={null}
      onCancel={onClose}
      width={showCadastroUnidades ? "700px" : undefined}
    >
      <Box>
        <FormGrupoUnidade
          visible={visible}
          defaultValue={defaultValue}
          onClose={onClose}
          editId={editId}
          showCadastroUnidades={showCadastroUnidades}
          onSuccess={async (result) => {
            onSuccess?.(result);
            onClose();
          }}
        />
      </Box>
    </Modal>
  );
}

export default ModalGrupoUnidade;
